import { render, staticRenderFns } from "./TxtViewer.vue?vue&type=template&id=26ffb64b&scoped=true&"
import script from "./TxtViewer.vue?vue&type=script&lang=js&"
export * from "./TxtViewer.vue?vue&type=script&lang=js&"
import style0 from "./TxtViewer.vue?vue&type=style&index=0&id=26ffb64b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26ffb64b",
  null
  
)

export default component.exports